var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('ContentOrLoading',{staticStyle:{"min-height":"200px"}},[(! _vm.loading)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h3',[_vm._v("Recaudación agrupada por sección y precio.")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.recaudacionSectoresPrecios}})],1)],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }